/**
 * HUB-609: a Postgres deadlock (40P01) or serialization failure (40001) rolled the whole
 * transaction back, so the request is safe to repeat. The server answers 409 with this `code`
 * (and no `conflict` payload) instead of a raw 500; offline replay retries it like a 5xx.
 */
export const DB_RETRYABLE_CONFLICT_CODE = "DB_RETRYABLE_CONFLICT";
export const DB_RETRYABLE_CONFLICT_MESSAGE = "Another save changed this at the same moment. Refresh and try again.";
